<template>
	<div>
	  <Header title="教学进度管理" type="0" :route="routPath"></Header>
	  <div class="eva-detail">
		<!-- 建议textarea评价 -->
		<template >
			<div>
				<van-field
					v-model="weekName"
					label="上课周次"
					left-icon="fire-o"
					right-icon="arrow"
					input-align="right"
					placeholder=""
					readonly
					/>
					<van-field
					v-model="classTime"
					label="上课时间"
					left-icon="location-o"
					right-icon="arrow"
					input-align="right"
					placeholder=""
					readonly
					/>
					<van-field
					v-model="xsflObj.textName"
					label="开课类型"
					left-icon="eye"
					right-icon="arrow"
					input-align="right"
					placeholder=""
					readonly
					/>
					<van-field
					v-model="xs"
					label="学时"
					left-icon="eye-o"
					right-icon="arrow"
					input-align="right"
					placeholder=""
					readonly
					/>		
					<van-field
					v-model="jxfsObj.textName"
					label="教学方式"
					left-icon="fire-o"
					right-icon="arrow"
					input-align="right"
					placeholder=""
					readonly
					@click="showMorePop('2')"
					/>
					<van-field
					v-model="skddObj.textName"
					label="授课场地"
					left-icon="location"
					right-icon="arrow"
					input-align="right"
					placeholder=""
					readonly
					/>	
					<van-field
					v-model="fzjzObj.textName"
					label="辅助教具"
					left-icon="smile-o"
					right-icon="arrow"
					input-align="right"
					placeholder=""
					@click="showMorePop('1')"
					readonly
					/>	
					<van-field
					v-model="sklsObj.textName"
					label="授课老师"
					left-icon="fire"
					right-icon="arrow"
					input-align="right"
					placeholder=""
					readonly
					/>									
			</div>
		</template>
		<template >
		  <div style="padding-left:10px">
			<p class="eva-topic" >
			 讲课章节及内容摘要
			</p>
			<div class="eva-rate" >
			  <keep-alive>
				<textarea
				  name
				  placeholder="请点击填写"
				  v-model="evaText"
				  maxlength="2000"
				></textarea>
			  </keep-alive>
			  <span>最多2000字符</span>
			</div>
		  </div>
		</template>
	  </div>
	  <div class="eva-buttons">
		<button v-if="isedid=='1'"
		  class="button"
		  @click="delRz()"
		  v-text="'删除'"
		  :style="'width:50%'"
		></button>
		<button v-else
		  class="button"
		  @click="close()"
		  v-text="'取消'"
		  :style="'width:50%'"
		></button>
		<button
		  class="eva-btn"
		  @click="saveRz()"
		  v-text="'保存'"
		  :style="'width:50%'"
		></button>
	  </div>

	  <van-popup v-model="show" round position="bottom">
      <van-picker
        :title="objList.tittle"
        show-toolbar
        :columns="objList.item"
        @cancel="show = false"
        @confirm="
          (value, index) => {
            onConfirm(value, index,objList.type);
          }
        "
    /></van-popup>
	</div>
  </template>
  
  <script>
  import { Api } from "../../../utils/axios";
  export default {
	data() {
	  return {
		pageData: [],
		dataObj:{},
		title: "",
		jx0404id:this.$route.query.jx0404id,
		week:this.$route.query.week,
		weekName:'第'+this.$route.query.week+"周",
		classTime:this.$route.query.classTime,
		classTableId:this.$route.query.classTableId,
		routPath:'/teacher/jxjdgl_deallist?jx0404id='+this.$route.query.jx0404id+'&itemObj='+this.$route.query.itemObj,
		evaText:'',
		xsfl:'',
		xs:(this.$route.query.classTime.length-1)/2,
		needfzgj:'',
		jxfsObj:{dm:'',textName:''},
		skddObj:{dm:'',textName:''},
		sklsObj:{dm:'',textName:''},
		jxfsList:[],
		xsflObj:{dm:'',textName:''},
		fzjzObj:{dm:'0',textName:'不需要'},
		show:false,
		fzjjList:[{'text':'不需要','value':'0'},{'text':'需要','value':'1'}],
		objList:{
			tittle:'',
			type:'',
			item:[]
		},
		itemObj:JSON.parse(this.$route.query.itemObj),
		isedit:this.$route.query.isedit,
	  };
	},
	methods: {
	  async initData(){
		const params = {
        jx0404id: this.jx0404id,
		zc:this.week,
		kcsj:this.classTime,
		jx0408id:this.classTableId,
		zzdtype:'currencyDic',
		tableName:'zzdskfs'
      };
	  
		const res = await Api.findCauseSkjhMsg(params);
		if(res.code=='1'){
			this.pageData = res.data;
			this.dataObj = this.pageData.length>0?this.pageData[0]:{};
			this.jxfsList = res.dicData;
			//初始化值
			this.xsflObj.dm = this.dataObj.xsfl;
			this.xsflObj.textName = this.dataObj.xsflmc;
			this.skddObj.dm = this.dataObj.jsid;
			this.skddObj.textName = this.dataObj.skdd,
			this.sklsObj.dm = this.dataObj.jgids,
			this.sklsObj.textName = this.dataObj.jgxm,
			this.fzjzObj.dm = this.dataObj.needfzdjvale,
			this.fzjzObj.textName = this.dataObj.needfzdj,
			this.jxfsObj.dm = this.dataObj.jxfs,
			this.jxfsObj.textName = this.dataObj.jxfsmc;
			this.evaText = this.dataObj.zjnr
		}
	  },
	  showMorePop(type) {
		this.show = true;
		this.objList.type=type;
		if(type=='1'){
			this.objList.title='需要辅助教具',
		   this.objList.item = this.fzjjList;
		}else if(type=='2'){
			this.objList.title='教学方式',
		   this.objList.item = this.jxfsList;
		}
		
	  },
	  onConfirm(value,index,type) {
		if(type==1){
			this.fzjzObj.dm = this.fzjjList[index].value;
			this.fzjzObj.textName = this.fzjjList[index].text;
		}else if(type==2){
			this.jxfsObj.dm = this.jxfsList[index].value;
			this.jxfsObj.textName = this.jxfsList[index].text;
		}
        this.show = false;
	    //this.xnxqObj.xnxqid = this.xnxqList[index].xnxq01id;
	  //this.xnxqObj.xnxqmc = this.xnxqList[index].xqmc;
      
    },
	async saveRz(){
		if(this.evaText==''){
			this.$toast("请填写讲课章节及内容摘要！");
			return;
		}
		if(this.jxfsObj.dm==undefined || this.jxfsObj.dm==''){
			this.$toast("请选择教学方式！");
			return;
		}
		const params = {
			zc:this.week,
			jx0404id:this.jx0404id,
			kcsj:this.classTime,
			skdd:this.skddObj.dm,
			skls:this.sklsObj.dm,
			needfzgj:this.fzjzObj.dm,
			sknr:this.evaText,
			jxfs:this.jxfsObj.dm,
			xsfl:this.xsflObj.dm,
			xs:this.xs
		}
		const res = await Api.saveMyjxjh(params);

		if(res.code=='1'){
			this.$toast("保存成功！");
			setTimeout(() => {
			 this.$router.push({
				path: this.routPath,
				
				});
        }, 1500);
		}
	},
	async delRz(){
		const params = {
			zc:this.week,
			jx0404id:this.jx0404id,
			kcsj:this.classTime,
			isdel:'1'
		}
		const res = await Api.saveMyjxjh(params);
		if(res.code=='1'){
			this.$toast("删除成功！");
			setTimeout(() => {
			 this.$router.push({
				path: this.routPath,
				
				});
        }, 1500);
		}
	},
	close(){
		this.$router.push({
				path: this.routPath,
				
				});
	}
	},
	created() {
		this.initData();
	}
  };
  </script>
 <style lang="less" scoped>
 .eva-detail {
   padding: 0 20px;
   margin-bottom: 20px;
 }
 .eva-detail .eva-num {
   color: @attendance-background-color-2;
   font-size: 18px;
 }
 .eva-detail .eva-num span {
   color: @attendance-background-color-1;
   font-size: 48px;
   font-weight: 600;
 }
 .eva-detail .eva-topic {
	font-family: PingFangSC-Medium;
	color: #757DA3;
   font-size: 15px;
   font-weight: 600;
   line-height: 25px;
 }
 .eva-detail .eva-rate {
   margin-top: 5px;
 }
 .eva-detail .eva-rate ul li {
   padding: 20px;
   font-weight: 600;
   border-radius: 5px;
   margin-bottom: 20px;
   background-color: @attendance-background-color-10;
   color: @attendance-color-1;
 }
 .eva-detail .eva-rate ul li.checked {
   padding: 20px;
   font-weight: 600;
   border-radius: 5px;
   margin-bottom: 20px;
   background-color: @attendance-background-color-12;
   color: @attendance-color-3;
 }
 .eva-detail .eva-rate textarea {
   width: 100%;
   padding: 10px;
   background-color: @attendance-background-color-6;
   border-radius: 3px;
   box-sizing: border-box;
   color: @attendance-color-1;
   height: 310px;
   padding-bottom: 15px;
 }
 .eva-detail .eva-rate textarea::placeholder {
   color: @attendance-color-2;
 }
 .eva-detail .eva-rate {
   position: relative;
 }
 .eva-detail .eva-rate span {
   color: @attendance-color-2;
   position: absolute;
   bottom: 3px;
   right: 10px;
   color: red;
   font-size: 12px;
 }
 .eva-buttons {
   position: relative;
   bottom: 0px;
   width: 100%;
   display: flex;
   justify-content: space-between;
   padding: 0 20px;
   box-sizing: border-box;
   padding: 20px;
   padding-top: 10px;
   background-color: @attendance-color-3;
   margin-top: 10px;
 }
 .eva-buttons button {
   border-radius: 3px;
   padding: 11px 0;
   width: calc(~"50% - 10px");
   margin: 5px;
   background-color: #f8f8f8;
 }
 .eva-buttons .eva-btn {
   background-color: @attendance-background-color-1;
   color: @attendance-color-3;
   margin: 5px;
 }
 .eva-buttons .pre-topic {
   background-color: @attendance-background-color-6;
   color: @attendance-background-color-1;
 }
   .dctitle{
	   color:@attendance-background-color-1;
	  font-weight: normal;
	 margin-bottom: 20px;
   }
   .fzinput{
	 border: 1px @attendance-color-2 solid;
	 width: 200px;
   }
 </style>
  


// WEBPACK FOOTER //
// src/components/teacher/jxjdgl/jxjdgl_dataEdatOrAdd.vue